
import type { PostStatus, PostVisibility } from './types';

export const POST_STATUS_LABELS: Record<PostStatus, string> = {
  DRAFT: 'Draft',
  IN_REVIEW: 'In Review',
  SCHEDULED: 'Scheduled',
  PUBLISHED: 'Published',
  ARCHIVED: 'Archived',
};

export const POST_STATUS_COLORS: Record<PostStatus, string> = {
  DRAFT: 'bg-muted text-muted-foreground',
  IN_REVIEW: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-500',
  SCHEDULED: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-500',
  PUBLISHED: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-500',
  ARCHIVED: 'bg-zinc-100 text-zinc-800 dark:bg-zinc-900/30 dark:text-zinc-500',
};

export const POST_VISIBILITY_LABELS: Record<PostVisibility, string> = {
  PUBLIC: 'Public',
  UNLISTED: 'Unlisted',
  PRIVATE: 'Private',
};

export const SEO_LIMITS = {
  META_TITLE_MAX: 70,
  META_DESCRIPTION_MAX: 160,
};

export const READING_SPEED_WPM = 200;
